import { defineStore } from 'pinia'
import axios from 'axios'

import { findIndexByParam } from '@/utils/findByParam'

export const headers = {
  'x-site-domain': window.location.hostname,
  Authorization: undefined, // Avoid sending auth if existing
}

export const usePublic = defineStore('public', {
  state: () => ({
    isLoading: false,
    customer: {},
    customerPreferences: {},
    preferences: {},
  }),
  actions: {
    async getPreferences(path) {
      this.isLoading = true
      const result = await axios.get(`customer/v1/preferences/${path}`, { headers })

      if (!result) return null

      // XXX but daddy swolio please...
      if (result.logo == null) {
        result.logo = undefined
      }

      this.preferences = result || {}
      this.preferences.lists = this.preferences.lists || []

      if (this.preferences.attrs?.separators) {
        this.preferences.attrs.separators.forEach((sep) => {
          this.preferences.lists.push({
            type: 'separator',
            label: sep.label,
            show_order: sep.show_order,
            icon: sep.icon,
            icon_color: sep.icon_color,
            text_style: sep.text_style,
            separator_color: sep.separator_color,
            createId: 'sep-' + Math.random().toString(36).substring(7),
          })
        })
      }

      this.preferences.lists.sort((a, b) => a.show_order - b.show_order)
      setTimeout(() => {
        this.isLoading = false
      }, 1000)

      return result
    },
    async getOrCreateCustomer(data) {
      this.isLoading = true

      const result = await axios.post('customer/v1/customers', data, { headers })

      this.customer = result

      this.isLoading = false

      return result
    },
    async getCustomerPreferences(customerId, path) {
      this.isLoading = true
      const result = await axios.get(`customer/v2/customers/${customerId}/preferences/${path}`, { headers })

      // XXX but daddy swolio please...
      if (result.logo == null) {
        result.logo = undefined
      }

      this.preferences = result || {}
      this.preferences.lists = this.preferences.lists || []

      if (this.preferences.attrs?.separators) {
        this.preferences.attrs.separators.forEach((sep) => {
          this.preferences.lists.push({
            type: 'separator',
            label: sep.label,
            show_order: sep.show_order,
            icon: sep.icon,
            icon_color: sep.icon_color,
            text_style: sep.text_style,
            separator_color: sep.separator_color,
            createId: 'sep-' + Math.random().toString(36).substring(7),
          })
        })
      }

      this.preferences.lists.sort((a, b) => a.show_order - b.show_order)
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
      setTimeout(() => {
        this.isLoading = false
      }, 1000)

      return result
    },
    async updateListValue(list, value) {
      if (!this.preferences?.lists) {
        return false
      }

      const index = findIndexByParam(this.preferences.lists, 'id', list)
      if (index === -1) {
        return false
      }

      this.preferences.lists[index].value = value
      return true
    },
    async updateCustomerPreferences({ id, preferences }) {
      // this.isLoading = true

      const result = await axios.put(`customer/v1/customers/${id}/lists`, preferences, { headers })

      this.customerPreferences = result
      // this.isLoading = false

      return result
    },
    async updateCustomer(id, data) {
      // this.isLoading = true
      const result = await axios.patch(`customer/v1/customers/${id}`, data, { headers })
      // this.isLoading = false

      return result
    },
    async updateCustomerGlobalUnsubscribe({ id, global_unsubscribe }) {
      return this.updateCustomer(id, { global_unsubscribe: global_unsubscribe })
    },
    async updateCustomerEmail({ id, email }) {
      return this.updateCustomer(id, { email: email })
    },
  },
})
